import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Aktuelle Reise',
    href: '#aktuelle-reise'
  }, {
    name: 'Konzept',
    href: '#konzept'
  }, {
    name: 'Models',
    href: '#models'
  }, {
    name: 'Teilnehmer',
    href: '#teilnehmer'
  }, {
    name: 'Galerie',
    href: '#galerie'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md py-4 border-b border-gray-200 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-301">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-302">
        <a href="#" className={`text-2xl font-sitename font-semibold tracking-widest uppercase transition-colors duration-300 ${isScrolled ? 'text-[#1a1a2e]' : 'text-white'}`} data-id="element-303">
          RAW<span className="text-brand-accent ml-1" data-id="element-304">Trips</span>
        </a>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-305">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors tracking-wide ${isScrolled ? 'text-[#4a4a5a] hover:text-brand-accent' : 'text-white/80 hover:text-white'}`} data-id="element-306">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-307">
          <a href="#bewerbung" className="px-6 py-2.5 bg-brand-accent/85 text-white font-medium text-sm rounded-sm hover:bg-brand-accent transition-colors duration-300" data-id="element-308">
            Bewerbung
          </a>
        </div>

        <button className={`md:hidden p-2 transition-colors duration-300 ${isScrolled ? 'text-[#1a1a2e]' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-309">
          {isMobileMenuOpen ? <XIcon size={24} className="text-[#1a1a2e]" data-id="element-310" /> : <MenuIcon size={24} data-id="element-311" />}
        </button>
      </div>

      <AnimatePresence data-id="element-312">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-white border-b border-gray-200 shadow-2xl md:hidden" data-id="element-313">
            <nav className="flex flex-col px-6 py-8 space-y-6" data-id="element-314">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-heading text-[#1a1a2e] hover:text-brand-accent transition-colors" data-id="element-315">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-gray-100" data-id="element-316">
                <a href="#bewerbung" onClick={() => setIsMobileMenuOpen(false)} className="inline-block w-full text-center px-6 py-3 bg-brand-accent/85 text-white font-medium rounded-sm hover:bg-brand-accent transition-colors" data-id="element-317">
                  Jetzt Bewerben
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}